import React from "react";
import orglogo from '../../assets/img/orglogo.png'
import EOTM from '../../assets/img/eotm-may.png';
import Loader from '../../utils/Loader';
import avatar from "../../assets/img/profile_av.jpg";


function Inhouse({ user, sums, tasks, notifs }) {
    return (
        <div className="row dash-row">
            <div className="col-md-8 col-sm-12 col-12">
                <div className="row d-flex">
                    <div className="col-md-6 col-sm-6 col-12">

                        <div className="card employee-welcome-card flex-fill mt-1">
                            <div className="card-body">
                                {(user && user.first_name) ? <>
                                <div className="welcome-info">
                                    <div className="welcome-content">
                                        <h5>Hello, {user && user.first_name} {user && user.last_name}</h5>
                                        <p>You have <span>Bi-monthly Meeting</span> on <span>July 1st 2024.</span></p>
                                    </div>
                                    <div className="welcome-img">
                                        <img src={avatar} className="img-fluid" alt="User" />
                                    </div>
                                </div>
                                <div className="welcome-btn">
                                    <a href="/profile" className="btn">View Profile</a>
                                </div>
                                </>: <Loader /> }
                            </div>
                        </div>

                        <div className="profilebox mb-4">
                            <div className="logobox">
                                <img src={orglogo} className="" alt="logo" width={40} height={40} />
                            </div>
                            <div className="namebox">
                                <h4>{(user && user.organization) ? `${user && user.organization?.name}` : 'loading...'}</h4>
                            </div>
                            <div className="detailbox">
                                <p><span className="title">Company ID</span> 
                                    <span className="det">RC999933</span>
                                </p>
                                <p><span className="title">Address</span> 
                                    <span className="det">Victoria Island, Lagos</span>
                                </p>
                            </div>
                        </div>

                    </div>

                    <div className="col-md-6 col-sm-6 col-12">
                        <div className="card flex-fill mt-1 task_statistics">
                            <div className="card-body">
                                <h5 className="card-title font-weight-bold">Task Statistics</h5>
                                <div className="statistics">
                                    {tasks && tasks.length > 0 ? 
                                    <div className="row">
                                        {tasks && tasks.map((task, i) => (
                                            <div className="col-md-6 col-6 text-center" key={i}>
                                                <div className="stats-box">
                                                    <p>{task.name && task.name}</p>
                                                    <h3 className={task.className && task.className}>
                                                        {task.count && task.count}
                                                    </h3>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    : <Loader /> }

                                    {/* <div className="row">
                                        <div className="col-md-6 col-6 text-center">
                                            <div className="stats-box">
                                                <p>Total Tasks</p>
                                                <h3 className="text-primary">385</h3>
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-6 text-center">
                                            <div className="stats-box">
                                                <p>Overdue Tasks</p>
                                                <h3 className="text-danger">19</h3>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>

                        <div className="card flex-fill mt-4 mb-4 task_statistics">
                            <div className="card-body">
                                <h5 className="card-title font-weight-bold">Attendance and Leave</h5>
                                <div className="statistics">
                                    {sums && sums.length > 0 ? 
                                    <div className="row">
                                        {sums && sums.map((sum,i) => (
                                            <div className="col-md-4 col-4 text-center" key={i}>
                                                <div className="stats-box">
                                                    <p>{sum.name && sum.name}</p>
                                                    <h3 className={sum.className && sum.className}>
                                                        {sum.count && sum.count}
                                                    </h3>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    : <Loader /> }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <div className="card employee-month-card flex-fill task_statistics mb-4">
                            <div className="card-body">
                                <div className="row align-items-center">
                                    <div className="col-lg-10 col-md-9 col-sm-9">
                                        <div className="employee-month-details">
                                            <h4>Employee of the month: <strong>May 2024</strong></h4>
                                            <p>We are really proud of the difference you have made which gives everybody the reason to applaud & appreciate</p>
                                        </div>
                                        <div className="employee-month-content">
                                            <h6>Congrats, Bunmni Akindahunsi</h6>
                                            <p>HR Consultant</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-2 col-md-3 col-sm-3">
                                        <div className="employee-month-img">
                                            <img src={EOTM} className="img-fluid" alt="User" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-4 col-sm-12 col-12">
                <div className="card flex-fill task_statistics mt-1">
                    <div className="card-body ">

                        <div className="statistic-header">
                            <h4>Notifications</h4>
                            <div className="important-notification">
                                <a href="/notifications">
                                    View All <i className="fa fa-arrow-circle-o-right"></i>
                                </a>
                            </div>
                        </div>

                        <div className="employee-noti-content notification_pad">
                            {notifs && notifs.length > 0 ? 
                                <ul className="employee-notification-list">
                                    {notifs && notifs.map((notif, i) => (
                                    <div className="employee-notification-grid" key={i} style={{width:"100%", marginLeft: -15}} >
                                        <div className="employee-notification-icon">
                                            <span className="badge-soft-danger rounded-circle">{i + 1}</span>
                                        </div>
                                        <div className="employee-notification-content">
                                            <h6>{notif.title && notif.title} </h6>
                                            <ul className="nav">
                                                <li>{notif.time && notif.time}</li>
                                                <li>{notif.date && notif.date}</li>
                                            </ul>
                                        </div>
                                    </div>
                                    ))}
                                </ul>
                            : null }
                        </div>
                    </div>
                </div>

                <div className="card info-card flex-fill task_statistics mt-4 mb-3">
                    <div className="card-body">
                        <h5>Holidays</h5>
                        <div className="holiday-details">
                            <div className="holiday-calendar">
                                <div className="holiday-calendar-icon">
                                    <img src={`https://smarthr.dreamstechnologies.com/html/template/assets/img/icons/holiday-calendar.svg`} alt="Icon" />
                                </div>
                                <div className="holiday-calendar-content">
                                    <h6>Id El Kabir</h6>
                                    <p>Mon 17th & Tue 18th June 2024</p>
                                </div>
                            </div>
                            <div className="holiday-btn">
                                <a href="https://www.timeanddate.com/holidays/nigeria/2024" target="_blank" rel="noreferrer"
                                className="btn">Learn More</a>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    );
}

export default Inhouse;